<!-- 打印单个标签 -->
<template>
    <div>
        <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%; padding-right: 30px" :rules="rules">
            <div class="form-main">
                <div class="print-msg">{{ printMsg }}</div>
            </div>
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="包装规格" prop="PackingSpec">
                        <el-input placeholder="数量" v-model="submitData.PackingSpec" @focus="focusSpec" @blur="blurSpec" @change="SpecChange">
                            <template slot="append">{{ unit }}</template>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="标签张数" prop="Amount">
                        <el-input-number style="width: 100%" v-model.trim="submitData.Amount" :max="Math.floor(canPrintCount / submitData.PackingSpec)" :min="1">
                        </el-input-number>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm" :disabled="!isCanSubmit">打印</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    // OType订单类型：0销售单，1采购单，2销售退货单，3采购退货单
    props: {
        EntpPOId: String,
        EntpGoodsId: String,
        OrderRsId: String,
        OType: {
            type: String,
            default: '0'
        }
    },
    components: {},
    data() {
        return {
            printMsg: '',
            canRequest: true,
            canPrintCount: 0,
            unit: '件',
            isCanSubmit: true,
            submitData: {
                PackingSpec: 1,
                EntpPOId: '',
                EntpOId:'',
                GoodsId: '',
                Amount: ''
            },
            rules: {
                PackingSpec: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Amount: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.submitData.EntpPOId = this.EntpPOId;
        this.submitData.EntpOId = this.EntpPOId;
        this.submitData.GoodsId = this.EntpGoodsId;
        this.submitData.OrderRsId = this.OrderRsId;
        this.getLabelData();
    },
    methods: {
        submitForm() {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    if (this.submitData.Amount > 0 && this.isCanSubmit) {
                        if (!this.canRequest) {
                            return;
                        }
                        this.canRequest = false;
                        if (this.OType == '0') {
                            this.$util
                                .axiosPost({
                                    url: '/api/EntpGoodsLabels/PrintSingleGoodsLabels',
                                    data: this.submitData,
                                    hideLoading: true
                                })
                                .then(res => {
                                    setTimeout(() => {
                                        this.canRequest = true;
                                    }, 1000);
                                    this.$util.successMsg(res.errmsg);
                                    this.$emit('closeDialog', true);
                                })
                                .catch(() => {
                                    this.canRequest = true;
                                });
                        } else if (this.OType == '2') {
                            let GoodsDatas = [];
                            GoodsDatas.push({ GoodsId: this.submitData.GoodsId, OrderRsId: this.submitData.OrderRsId });
                            this.submitData.GoodsDatas = GoodsDatas;
                            this.$util
                                .axiosPost({
                                    url: '/api/EntpGoodsLabels/PrintSalesRetrunGoodsLabels',
                                    data: this.submitData,
                                    hideLoading: true
                                })
                                .then(res => {
                                    setTimeout(() => {
                                        this.canRequest = true;
                                    }, 1000);
                                    this.$util.successMsg(res.errmsg);
                                    this.$emit('closeDialog', true);
                                })
                                .catch(() => {
                                    this.canRequest = true;
                                });
                        } else {
                            this.$util.warningMsg('未知的订单类型');
                        }
                    } else this.$util.warningMsg('打印张数必须大于0');
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        SpecChange(val) {
            // this.submitData.Amount = Math.floor(this.canPrintCount / val);
            this.submitData.Amount = 1;
        },
        focusSpec() {
            this.isCanSubmit = false;
        },
        blurSpec() {
            setTimeout(() => {
                this.isCanSubmit = true;
            }, 500);
        },
        getLabelData() {
            let that = this;
            if (this.OType == '0') {
                that.$util
                    .axiosGet({
                        url: '/api/EntpGoodsLabels/GetSingleGoodsLabel',
                        data: {
                            EntpPOId: that.submitData.EntpPOId,
                            EntpGoodsId: that.submitData.GoodsId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            if (data.WarehousedCount > data.InLabelCount) {
                                that.canPrintCount = data.GoodsCount - data.PrintedCount - (data.WarehousedCount - data.InLabelCount);
                            } else that.canPrintCount = data.GoodsCount - data.PrintedCount;

                            that.unit = data.Unit;
                            that.printMsg = '【' + data.GoodsName + '】 可打印标签数量为：' + that.canPrintCount + ' ' + data.Unit;
                            // that.submitData.Amount = that.canPrintCount;
                            that.submitData.Amount = 1;
                        } else that.printMsg = '商品信息获取失败！';
                    })
                    .catch(() => {});
            } else {
                that.$util
                    .axiosGet({
                        url: '/api/EntpGoodsLabels/GetSReturnSingleGoodsLabel',
                        data: {
                            SaleROrderId: that.submitData.EntpPOId,
                            EntpGoodsId: that.submitData.GoodsId,
                            OrderRsId: that.submitData.OrderRsId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            if (data.WarehousedCount > data.InLabelCount) {
                                that.canPrintCount = data.GoodsCount - data.PrintedCount - (data.WarehousedCount - data.InLabelCount);
                            } else that.canPrintCount = data.GoodsCount - data.PrintedCount;

                            that.unit = data.Unit;
                            that.printMsg = '【' + data.GoodsName + '】 可打印标签数量为：' + that.canPrintCount + ' ' + data.Unit;
                            that.submitData.Amount = 1;
                        } else that.printMsg = '商品信息获取失败！';
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;
}
.dialog-footer {
    text-align: right;
}
.print-msg {
    margin-bottom: 15px;
    font-size: 16px;
    color: rgb(238, 122, 122);
}
</style>
